<template>
  <div v-if="!isNull(datacollection)" :class="'chart_container '+height">
    <Line :data="datacollection" :options="options" :style="'width:100%;height:'+height+'px'"></Line>
    <!-- <button @click="fillData()">Randomize</button> -->
  </div>
</template>

<script>
import { Line } from 'vue-chartjs'
import { Chart as ChartJS,PointElement, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale ,LineElement, Filler} from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,PointElement,LineElement, Filler)

  export default {
    props: ["data"/*, "options"*/,"grid_color","ticks","display","gridLines","height","oneLine","multiple", "x" , "y","legend_label","legend"],
    components: {
      Line
    },
    data () {
      return {
        datacollection: null,
          options: {
            hover: {
              intersect: false
            },
            interaction: {
              mode: 'nearest'
            },
            elements: {
              point:{
                radius: 0
              }
            },
            responsive: true, 
            maintainAspectRatio: false,
            onClick: this.onClick,
            legend:{
              position:'bottom',
              display:this.legend
            },
            tooltips: {
              mode: 'nearest',
              intersect: false,
            },
            scales: { 
                xAxes: {
                  ticks: {
                      display: this.x
                  },
                stacked: true,
                categoryPercentage: 0.5,
                gridLines: {
                  color: this.grid_color,
                  display:this.gridLines
                },
                barPercentage: 1
              },
              yAxes: {
                ticks: {
                display: this.y
              },
              gridLines: {
                color: this.grid_color,
                display:true
              },
              stacked: true
            }
          }
        }
      }
    },
    mounted () {

     setTimeout(() => {
      this.fillData();
     },100);

    }, 
    methods: {
  
       fillData () {

        if (!this.isNull(this.data)) 
        {
          this.datacollection = {
            labels: this.data.labels.map((row) => { return row}),
             datasets: []
          }
          
            let datasets = [];
            let data = [];
            let backgroundColor = [];
            let label = [];

            
              datasets.push({
                    fill: true,
      
                    data: [],
              
                })
            
              for (let i in this.data.labels)
            {
              data.push(this.data.datasets[0].data[i])
              backgroundColor.push(this.color_array[i],)
              label.push(this.data.labels[i].label)
            }

            
            this.datacollection.datasets = datasets;
            this.datacollection.datasets[0].data = data;
            this.datacollection.datasets[0].backgroundColor = 'transparent';
            this.datacollection.datasets[0].borderColor = this.color_array;
            this.datacollection.datasets[0].label = this.legend_label;
       
        }

      },
          
          
          }
          }
          
          
        

      
    
  
</script>

<style>
.chart_container > div{height: 320px;position: relative;}
</style>
